
import { addMinutes, format, parse } from 'date-fns';

/**
 * Génère les créneaux horaires
 * @param slotDuration - Durée d'un créneau en minutes
 * @param startTimeStr - Heure de début (format "HH:mm")
 * @param endTimeStr - Heure de fin (format "HH:mm")
 */
export const generateTimeSlots = (
  slotDuration: number = 45,
  startTimeStr: string = "08:00",
  endTimeStr: string = "21:00"
): string[] => {
  const slots: string[] = [];
  const startTime = parse(startTimeStr, "HH:mm", new Date());
  const endTime = parse(endTimeStr, "HH:mm", new Date());
  let currentTime = startTime;

  while (currentTime <= endTime) {
    slots.push(format(currentTime, "HH:mm"));
    currentTime = addMinutes(currentTime, slotDuration);
  }

  return slots;
};

/**
 * Calcule la position et l'étendue d'un cours dans la grille
 * @param startTime - Heure de début du cours (format "HH:mm")
 * @param classDuration - Durée du cours en minutes (string ou number)
 * @param slotDuration - Durée d'un créneau d'affichage en minutes
 * @param baseTimeStr - Heure de référence (format "HH:mm", par défaut "08:00")
 */
export const calculateClassPosition = (
  startTime: string,
  classDuration: string | number = "45",
  slotDuration: number = 45,
  baseTimeStr: string = "08:00"
) => {
  const [hours, minutes] = startTime.split(':').map(Number);
  const durationMinutes = typeof classDuration === 'string' 
    ? parseInt(classDuration) 
    : classDuration;
  
  // Calcul de la position de départ (en slots depuis l'heure de base)
  const startTimeInMinutes = (hours * 60) + minutes;
  const [baseHours, baseMinutes] = baseTimeStr.split(':').map(Number);
  const baseTimeInMinutes = (baseHours * 60) + baseMinutes;
  const minutesSinceBaseTime = startTimeInMinutes - baseTimeInMinutes;
  
  // Nombre de slots depuis le début
  const slotsSinceStart = Math.floor(minutesSinceBaseTime / slotDuration);
  
  // Nombre de slots occupés par le cours (arrondi supérieur)
  const durationSlots = Math.ceil(durationMinutes / slotDuration);
  
  return {
    startSlot: slotsSinceStart,
    slotSpan: durationSlots
  };
};
